<template>
	<!-- <content-head title="Home" /> -->
	<heading />
	<content class="">
		<div class="row">
			<div class="card custom-card col-xl-12 rounded-0 border-0 shadow">
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i
													class="nav-icon fas fa-hand-holding-usd"
												></i
												>&nbsp;&nbsp;Finance&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">&nbsp;&nbsp;Tour Quotes&nbsp;&nbsp;</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</content>
</template>

<script>
export default {
	components: {},
	data() {
		return {};
	},
	computed: {},
	methods: {},
	created() {},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {
		clearInterval(this.timer);
	},
};
</script>



